<section class="flex h-full w-full flex-col bg-transparent" aria-label="Questões da avaliação" cdkDropListGroup>
  <div class="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto bg-transparent">
    @if (questions.length > 0) {
      <ul
        cdkDropList
        class="m-0 flex list-none flex-col gap-3 bg-transparent p-0"
        [cdkDropListData]="questions.controls"
        (cdkDropListDropped)="onQuestionsReordered($event)"
      >
        @for (question of questions.controls; track question.controls.id.value; let i = $index) {
        <li
          cdkDrag
          cdkDragLockAxis="y"
          class="block w-full"
          [cdkDragData]="question"
        >
          <article class="overflow-hidden rounded-xl bg-lGray900">
            <div class="flex items-center gap-3 px-4 py-4">
              <button
                type="button"
                cdkDragHandle
                class="flex shrink-0 cursor-grab touch-none items-center justify-center text-lGray600 transition-colors active:cursor-grabbing"
                aria-label="Reordenar questão"
                (click)="$event.stopPropagation()"
              >
                <l-icon class="text-2xl">menu</l-icon>
              </button>

              <span class="flex-1 text-sm font-medium text-lGray50">
                Questão {{ i + 1 }}
              </span>

              <button
                type="button"
                class="flex shrink-0 items-center justify-center text-lDanger transition-opacity hover:opacity-80"
                aria-label="Excluir questão"
                (click)="onDeleteQuestion(question.controls.id.value); $event.stopPropagation()"
              >
                <l-icon class="text-lg">delete</l-icon>
              </button>

              <button
                type="button"
                class="flex shrink-0 items-center justify-center text-lGray500 transition-colors hover:text-lGray300"
                [attr.aria-label]="isExpanded(question.controls.id.value) ? 'Recolher questão' : 'Expandir questão'"
                (click)="toggleQuestion(question.controls.id.value)"
              >
                <l-icon
                  class="text-xl transition-transform duration-300 will-change-transform"
                  [style.transform]="isExpanded(question.controls.id.value) ? 'rotate(180deg)' : 'rotate(0deg)'"
                >expand_more</l-icon>
              </button>
            </div>

            <div
              class="grid transition-[grid-template-rows] duration-300"
              [ngClass]="{
                'grid-rows-[1fr]': isExpanded(question.controls.id.value),
                'grid-rows-[0fr]': !isExpanded(question.controls.id.value)
              }"
            >
              <div class="overflow-hidden">
                <div class="flex flex-col gap-4 border-t border-lGray700 px-4 py-4">
                  <div class="flex flex-col gap-1.5">
                    <label
                      class="text-sm font-medium text-lGray500"
                      [for]="'question-text-' + question.controls.id.value"
                    >Enunciado da questão</label>
                    <textarea
                      class="min-h-16 w-full resize-none rounded-xl border-0 bg-lGray950 px-4 py-3 text-base text-lWhite outline-none transition-colors duration-200 placeholder:text-lGray600 focus:bg-lGray700"
                      rows="3"
                      placeholder="Digite o enunciado da questão"
                      [id]="'question-text-' + question.controls.id.value"
                      [formControl]="question.controls.text"
                    ></textarea>
                  </div>

                  <div class="flex flex-col gap-1.5">
                    <label
                      class="text-sm font-medium text-lGray500"
                      [for]="'question-image-url-' + question.controls.id.value"
                    >Imagem URL (Opcional)</label>
                    <div class="relative">
                      <l-icon class="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg text-lGray600">image</l-icon>
                      <input
                        type="url"
                        class="h-12 w-full rounded-xl border-0 bg-lGray950 pl-11 pr-4 text-base text-lWhite outline-none transition-colors duration-200 placeholder:text-lGray600 focus:bg-lGray700"
                        placeholder="Coloque aqui a URL da imagem"
                        [id]="'question-image-url-' + question.controls.id.value"
                        [formControl]="question.controls.imageUrl"
                      />
                    </div>
                  </div>

                  <div class="flex flex-col gap-2">
                    <span
                      class="text-sm font-medium text-lGray500"
                      [id]="'question-options-label-' + question.controls.id.value"
                    >Alternativas</span>

                    <ul
                      cdkDropList
                      class="drag-sort-list m-0 flex list-none flex-col gap-3 p-0"
                      [cdkDropListData]="question.controls.options.controls"
                      [attr.aria-labelledby]="'question-options-label-' + question.controls.id.value"
                      (cdkDropListDropped)="onOptionsReordered(question.controls.id.value, $event)"
                    >
                      @for (option of question.controls.options.controls; track option.controls.id.value; let j = $index) {
                        <li
                          cdkDrag
                          cdkDragLockAxis="y"
                          class="drag-sort-item block w-full"
                          [cdkDragData]="option"
                        >
                          <l-sortable-card dragHandleAriaLabel="Reordenar alternativa">
                            <span class="shrink-0 text-sm font-medium text-lGray50">
                              Alternativa {{ getOptionLabel(j) }}
                            </span>

                            <input
                              type="text"
                              class="h-12 min-w-0 flex-1 rounded-2xl border-0 bg-lGray950 px-4 text-base text-lGray500 outline-none transition-colors duration-200 placeholder:text-lGray600 focus:bg-lGray700 focus:text-lWhite"
                              [placeholder]="'Alternativa ' + getOptionLabel(j)"
                              [formControl]="option.controls.text"
                              [attr.aria-label]="'Texto da alternativa ' + getOptionLabel(j)"
                            />

                            <div sortableCardActions class="flex shrink-0 items-center gap-3">
                              <button
                                type="button"
                                class="flex shrink-0 items-center gap-1.5 transition-opacity hover:opacity-80"
                                [attr.aria-label]="'Marcar alternativa ' + getOptionLabel(j) + ' como correta'"
                                (click)="onSetCorrectOption(question.controls.id.value, option.controls.id.value)"
                              >
                                <span
                                  class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 transition-colors"
                                  [ngClass]="{
                                    'border-lPrimary bg-lPrimary': option.controls.isCorrect.value,
                                    'border-lGray600': !option.controls.isCorrect.value
                                  }"
                                >
                                  @if (option.controls.isCorrect.value) {
                                    <l-icon class="!text-base leading-none text-white">check</l-icon>
                                  }
                                </span>
                                <span class="whitespace-nowrap text-sm text-lGray50">Alternativa correta</span>
                              </button>

                              @if (question.controls.options.length > 2) {
                                <button
                                  type="button"
                                  class="flex shrink-0 items-center justify-center text-lDanger transition-opacity hover:opacity-80"
                                  aria-label="Remover alternativa"
                                  (click)="onRemoveOption(question.controls.id.value, option.controls.id.value)"
                                >
                                  <l-icon class="text-xl">delete</l-icon>
                                </button>
                              }
                            </div>
                          </l-sortable-card>
                        </li>
                      }
                    </ul>

                    @if (question.controls.options.length < maxOptions) {
                      <div class="flex justify-center pt-4">
                        <button
                          type="button"
                          class="inline-flex items-center gap-2 rounded-3xl bg-lGray50 px-6 py-2.5 text-base font-medium text-lBlack transition duration-200 hover:brightness-105 active:brightness-95"
                          (click)="onAddOption(question.controls.id.value)"
                        >
                          Adicionar alternativa
                          <span class="text-xl font-normal leading-none" aria-hidden="true">+</span>
                        </button>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </article>

          <ng-template cdkDragPlaceholder>
            <article class="pointer-events-none flex items-center gap-3 rounded-xl bg-lGray900 px-4 py-4 opacity-50">
              <span class="flex shrink-0 items-center justify-center text-lGray600 opacity-0" aria-hidden="true">
                <l-icon class="text-2xl">menu</l-icon>
              </span>
              <span class="flex-1 text-sm font-medium text-lGray50">Questão {{ i + 1 }}</span>
            </article>
          </ng-template>
        </li>
        }
      </ul>
    }

    @if (questions.length < 10) {
      <div class="flex justify-center">
        <button
          type="button"
          lButton
          [bType]="buttonTypeEnum.PRIMARY"
          [bSize]="buttonSizeEnum.MEDIUM"
          [bRadius]="buttonRadiusEnum.LARGE"
          class="inline-flex items-center gap-2"
          (click)="onAddQuestion()"
        >
          Adicionar questão
          <l-icon class="text-lg">add</l-icon>
        </button>
      </div>
    }
  </div>
</section>
